<template>
<div class="fullcontainer centerbg" style="background-image:url('res/p3/ccyjsbg.jpg');">
<!-- <keep-alive> -->
  <component :is="currentView" ref="component"></component> 
<!-- </keep-alive> -->
</div>
</template>

<script>
// import { url } from "@/d";
import P3_1 from "@/component/P3_1";
import P3_2 from "@/component/P3_2";
import P3_3 from "@/component/P3_3";
import P3_4 from "@/component/P3_4";
import P3_5 from "@/component/P3_5";
import P3_6 from "@/component/P3_6";

const components = {P3_1,P3_2,P3_3,P3_4,P3_5,P3_6};

export default {
  data() {
    return {
      currentView: P3_1
    };
  },

 mounted() {
    this.$root.$on("P3SwitchTo", this.SwitchTo);
  },

  beforeDestroy(){
    this.$root.$off("P3SwitchTo", this.SwitchTo);
  },

  methods: {
    SwitchTo(pageName){
      this.currentView = components[pageName];
      // if(this.$refs.component.onShow)
      // {
      //   this.$refs.component.onShow();
      // }
    }
  },

  components
};
</script>

<style lang="scss">
@import "D:/workspace/all_web/src/_cmm/css/centerbg.scss";
@import "D:/workspace/all_web/src/_cmm/css/horizontalCenterPercent.scss";

.p1bg {
  @include centerbg; //'res/p1/bg.png'
  // background: url("../../public/res/p1/bg.png");
  .bt {
    @include horizontalCenterPercent(80%);
    top: 1%;
  }

  .xyr {
    width: 35%;
    right: 2%;
    bottom: 2%;
  }

  .dt_cont {
    position: relative;
    top: 26%;

    .dt {
      @include horizontalCenterPercent(100%);
      // top: 30%;
    }

    .sxjt {
      width: 30%;
      top: -18vw;
      left: 18vw;
    }

    .jgc {
      width: 30%;
      top: -8vw;
      right: 9vw;
    }

    .yzjd {
      width: 28%;
      top: 45vw;
      left: 22vw;
    }
  }
}
</style>
